import { render, staticRenderFns } from "./XYPlot.vue?vue&type=template&id=20c57c6e&scoped=true&"
import script from "./XYPlot.vue?vue&type=script&lang=js&"
export * from "./XYPlot.vue?vue&type=script&lang=js&"
import style0 from "./XYPlot.vue?vue&type=style&index=0&id=20c57c6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c57c6e",
  null
  
)

export default component.exports